import { Types } from "../Constants/Types";
import { initialErrors } from '../Constants/Sections.constants';

interface CategoryState {
  isLoading: boolean;
  categories: any[];
  category: any;
  subcategories: any[];
  pages: number;
  errors: {
    field: string;
    message: string;
  }[];
  lcategories: boolean;
  lcategory: boolean;
  lsubcategories: boolean;
  error: {
    [key: string]: string | null;
  };
}

const initialState: CategoryState = {
  isLoading: false,
  categories: [],
  category: null,
  subcategories: [],
  pages: 0,
  errors: [],
  lcategories: false,
  lcategory: false,
  lsubcategories: false,
  error: initialErrors,
};

const categoriesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Loading states
    case Types.START_CATEGORIES:
      return { ...state, isLoading: true, lcategories: true };
    case Types.END_CATEGORIES:
      return { ...state, isLoading: false, lcategories: false };
    case Types.START_CATEGORY:
      return { ...state, isLoading: true, lcategory: true };
    case Types.END_CATEGORY:
      return { ...state, isLoading: false, lcategory: false };
    case Types.START_SUBCATEGORIES:
      return { ...state, isLoading: true, lsubcategories: true };
    case Types.END_SUBCATEGORIES:
      return { ...state, isLoading: false, lsubcategories: false };

    // Data states
    case Types.FETCH_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        pages: action.pages,
      };
    case Types.SEARCH_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
        pages: action.pages,
      };
    case Types.FETCH_CATEGORY:
      return { ...state, category: action.payload };
    case Types.FETCH_SUBCATEGORIES:
      return { ...state, subcategories: action.payload };
    case Types.CLEAR_SUBCATEGORIES:
      return { ...state, subcategories: [] };
    case Types.CREATE_CATEGORY:
      return {
        ...state,
        categories: [action.payload, ...state.categories],
      };
    case Types.UPDATE_CATEGORY:
      return {
        ...state,
        categories: state.categories.map(category => category._id === action.payload.id ? action.payload : category),
      };
    case Types.DELETE_CATEGORY:
      return {
        ...state,
        categories: state.categories.filter(
          (category) => category._id !== action.payload
        ),
      };
    case Types.STATE_CATEGORY:
      return {
        ...state,
        categories: state.categories.map(category => 
          category._id === action.payload.id ? {...category, state: action.payload.state} : category
        ),
      };
    case Types.POSITION_CATEGORY:
      return {
        ...state,
        categories: state.categories.map(category => 
          category._id === action.payload.id ? {...category, position: action.payload.position} : category
        ),
      };

    // Error states
    case Types.ERROR_CATEGORY:
      return {
        ...state,
        error: action?.payload ? {...state.error, [action?.field]: action.payload} : {...state.error, [action?.field]: null},
      };
    case Types.RESET_CATEGORY:
      return { ...state, error: initialErrors };

    default:
      return state;
  }
};

export default categoriesReducer; 